import PropTypes from "prop-types";

const propTypes = {
  onSkipClick: PropTypes.func.isRequired,
  onBackClick: PropTypes.func
};

export default propTypes;
